<style lang="stylus">
@import '../../common/stylus/variable'
.welcome-wrapper {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #111;

  .welcome-main,
  .welcome-secondary {
    position: absolute;
    left: 0;
    width: 100vw;
    object-fit: cover;
  }

  .welcome-main {
    top: 0;
    height: 100vh;
  }

  .welcome-secondary {
    bottom: 0;
    height: auto;
  }

  .hide-btn {
    position: fixed;
    right: 4vw;
    top: 3vh;
    min-width: 1.9rem;
    padding: 0.16rem 0.3rem;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    border: none;
    border-radius: 999px;
    font-size: 0.3rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.2);
  }
}
</style>
<template>
  <div class="welcome-wrapper">
    <template>
      <img :src="images[0]" alt="" class="welcome-main">
      <img :src="images[1]" alt="" class="welcome-secondary">
    </template>
    <button class="hide-btn" @click.stop="hideImg">{{ seconds }} 跳过</button>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import {getUserIdentity, getWelcomeImage} from 'src/components/api/interface-hhy';

/**
 * 应用启动欢迎页
 * 应用进入时显示，5S后自动隐藏，用户点击【跳过】时隐藏
 */
export default {
  // 使用其它组件
  components: {},
  // 属性
  data() {
    return {
      seconds: 4,
      timerId: null,
      identity: getUserIdentity(),
      images: []
    }
  },
  // 计算属性
  computed: {
    ...mapState(['welcomeImgVisible'])
  },
  watch: {},
  // 生命周期函数
  created() {
    getWelcomeImage().then(res => {
      this.images = res;
    }).catch(() => {
      console.log('welcome-images-error');
    });
    this.timerId = setInterval(() => {
      this.seconds--;
      if (this.seconds <= 0) {
        this.setWelcomeImgVisible(false);
        clearInterval(this.timerId);
      }
    }, 600);
  },
  mounted() {
  },
  methods: {
    ...mapMutations(['setWelcomeImgVisible']),
    hideImg() {
      this.setWelcomeImgVisible(false);
      clearInterval(this.timerId);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Welcome.vue